import type { TaskProposal } from '@/types/process'
import { ProposalRationale } from './ProposalRationale'
import { formatConfidence } from './proposalText'

/** What the AI suggested on a task that is no longer a form (done) — the
 * exit, the confidence, and the rationale behind the same disclosure. */
export function ProposalSummary({ proposal }: { proposal: TaskProposal }) {
  const confidence = formatConfidence(proposal.confidence)
  return (
    <div className="space-y-1">
      <p className="text-sm text-muted-foreground">
        The AI suggested {proposal.exit ? `“${proposal.exit}”` : 'field values'}{confidence ? ` · ${confidence}` : ''}
      </p>
      {proposal.rationale && <ProposalRationale rationale={proposal.rationale} />}
    </div>
  )
}
